import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadDriverCardByIdFailed,
  loadDriverCardByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* loadDriverCardById(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/drivers/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield getBodyJson(dataResponse);
      yield put(loadDriverCardByIdSuccessful(data?.data));
      yield call(resolveActionPromise(action, data?.data));
    } else {
      yield put(loadDriverCardByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadDriverCardByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
